import InsectV2View from './InsectV2View';

export default InsectV2View;
